import axios from "axios";
import dayjs, { Dayjs } from "dayjs";
import { DateRange } from "@mui/x-date-pickers-pro";
import { MaterialReactTable } from "material-react-table";
import { useEffect, useState } from "react";
import { UrlUpdateType } from "use-query-params";
import { ContactWithSuspectedMatch } from "../../phonebook/types";
import { suspectedMatchesColums } from "./SuspectedMatchesColumns";
import SuspectedMatchesActions from "./SuspectedMatchesActions";
import Iconify from "../../../minimals/components/iconify";
import { IconButton, Tooltip } from "@mui/material";

interface Props {
  selectedEntityId?: number;
  setSelectedEntityId: (newValue: string | null | undefined, updateType?: UrlUpdateType) => void;
}

const IndividualSuspectedMatchesTab = ({ selectedEntityId, setSelectedEntityId }: Props) => {
  const today = dayjs();
  const defaultEndDate = today.endOf("day");
  const defaultStartDate = today.subtract(7, "days").startOf("day");
  const [loading, setLoading] = useState(true);
  const [suspectedMatch, setSuspectedMatch] = useState<ContactWithSuspectedMatch[]>([]);
  const [dateRange, setDateRange] = useState<DateRange<Dayjs>>([defaultStartDate, defaultEndDate]);
  const [enableOrdering, setEnableOrdering] = useState(false);
  const getSuspectedMatches = async () => {
    setLoading(true);
    const [startDate, endDate] = dateRange;

    const fromParam = (startDate?.startOf("day") || defaultStartDate).format("YYYY-MM-DD");
    const toParam = (endDate?.endOf("day") || defaultEndDate).format("YYYY-MM-DD");

    const url = `/api/clientphonebook/contacts/getSuspectedMatches?from=${fromParam}&to=${toParam}`;
    const { data } = await axios.get(url);
    setSuspectedMatch(data);
    setLoading(false);
  };

  useEffect(() => {
    getSuspectedMatches();
  }, [dateRange]);
  return (
    <>
      <MaterialReactTable
        enableStickyHeader
        muiTableBodyProps={{
          sx: {
            "& .MuiTableRow-root:hover .MuiTableCell-root": {
              backgroundColor: "inherit !important"
            }
          }
        }}
        muiTableBodyRowProps={({ row }) => {
          return {
            style: row.index % 2 === 0 ? {} : { backgroundColor: "#f4f4f4" }
          };
        }}
        columns={suspectedMatchesColums({ setSuspectedMatch, suspectedMatch })} // Pass state setter
        data={suspectedMatch}
        enableGlobalFilter
        enableFacetedValues
        enableColumnOrdering={enableOrdering}
        initialState={{
          density: "compact",
          pagination: { pageIndex: 0, pageSize: 30 },
          columnVisibility: {
            transactionType: false,
            voidedOn: false,
            status: false,
            extendedMemo: false
          }
        }}
        state={{
          showSkeletons: loading
        }}
        renderTopToolbarCustomActions={({ table }) => {
          return (
            <>
              <SuspectedMatchesActions dateRange={dateRange} setDateRange={setDateRange} table={table} />
              <Tooltip title="Column ordering">
                <IconButton
                  onClick={() => setEnableOrdering(!enableOrdering)}
                  aria-label="toggle column ordering"
                  style={{ position: "absolute", right: "200px" }}
                >
                  <Iconify icon="mdi:reorder-vertical" />
                </IconButton>
              </Tooltip>
            </>
          );
        }}
      />
    </>
  );
};

export default IndividualSuspectedMatchesTab;
